import { DISCOUNT_OPTIONS } from "../planner.constants.js";

export const getDiscountedValue = (value, discount, unit) => {
  if (unit === DISCOUNT_OPTIONS.value) return value - (discount || 0);
  if (unit === DISCOUNT_OPTIONS.percentage) {
    if (!discount) return value;
    const discountedVal = (discount / 100) * value;
    return value - discountedVal;
  }
};
